import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, Alert } from 'reactstrap'
import { FaUserCog } from 'react-icons/fa'
import { ADMIN_MENU_ITEMS_QUERY } from '../../graphql.js'
import AdminMenuItem from '../AdminMenuItem/AdminMenuItem'
import { handleGraphQLErrors } from '../../utils.js'

const ADMIN_MENU_ITEMS = gql(ADMIN_MENU_ITEMS_QUERY)

export default function AdminMenu() {
  console.log('AdminMenu rendered')

  const [items, setItems] = useState([])
  const [graphQLErrors, setGraphQLErrors] = useState([])
  useEffect(() => {
    let mounted = true
    async function fetchItems() {
      try {
        const { data, errors } = await window.apolloClient.query({ query: ADMIN_MENU_ITEMS })
        if (data.adminMenuItems) {
          const menuItems = []
          for (let item of data.adminMenuItems) {
            menuItems.push(<AdminMenuItem key={item.text} item={item} />)
          }
          if (mounted) {
            setItems(menuItems)
          }
        } 
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      }
    }
    fetchItems()
    return (() => mounted = false)
  }, [])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (items.length > 0) {
    return (
      <UncontrolledDropdown nav inNavbar>
        <DropdownToggle nav caret data-cy="admin-menu">
          <b><FaUserCog style={{ verticalAlign: 'baseline' }} /> Administration</b>
        </DropdownToggle>
        <DropdownMenu style={{ maxHeight: '500px', overflow: 'auto' }}>
          {items}
        </DropdownMenu>
      </UncontrolledDropdown>
    )
  }
  return ''
}
